import { Component, ViewChild, ElementRef } from '@angular/core';
import { NavController, NavParams, Platform, Events, ModalController, Keyboard } from 'ionic-angular';
import { ViewController } from 'ionic-angular/navigation/view-controller';
import { CoReservationDetailsComponent } from '../../components/co-reservation-details/co-reservation-details';
import moment from 'moment';
import { ReserveProvider } from '../../providers/reserve/reserve';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { CoTcModalPage } from '../co-tc-modal/co-tc-modal';
import { ToastAlertsProvider } from '../../providers/toast-alerts/toast-alerts';
import { TimeoutFunctionsProvider } from '../../providers/timeout-functions/timeout-functions';
import { SoundsProvider } from '../../providers/sounds/sounds';
import { AppState } from '../../config/state';
import { AppBlock, ReserveBlock } from '../../providers/config/config';
import { ClientDetailsProvider } from '../../providers/client-details/client-details';

/**
 * Generated class for the CoCartPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-co-cart',
  templateUrl: 'co-cart.html',
})
export class CoCartPage {
  mode: string = "multi";
  numberOfItems: number;
  allItems: any;
  currentItem: any;
  currentItemIndex: number = 0;
  clientKeyword: string;
  currentLocationName: any;
  nextEnable: boolean = true;
  previousEnable: boolean = false;
  submitEnable: boolean = false;
  checkoutScreen: boolean = true;
  termsOfServiceChecked = false;
  finalCost: number;
  contentContainer: any;
  viewingCart: boolean = true;
  previousPage: any;
  isPopover: boolean = false;
  isCostEnabled: boolean;
  allRequiredFieldsFilled: boolean = false;
  paymentType: string = 'card';
  // needToUpdateCart: boolean = false;
  clientRoomSettings: any;
  emailRegex: any;
  phoneRegex: any;
  cvvRegex: any;
  validationObject: any = { email: true, phone: true };
  cardInfoIsEntered: any = { cardNum: true, cvvNum: true, expDate: true, firstName: true, lastName: true };
  cardInfoObject: any = {};
  emptyInputFieldStatus: boolean = false;
  minimumDateForCard: string = moment().format('YYYY-MM-DD');
  viewType: any;
  clientName: string;
  barcode: string;
  detailsScreen: any;
  libraryCardRequired: boolean = false;
  hideLibraryCardAndPin: boolean = false;
  pinlessAuth: boolean;
  tcOptional: boolean;
  hideNotes: boolean;
  sharedScreen: boolean = false;
  blockSettings: ReserveBlock;
  showEmailInputAnyway: boolean = false;
  showPhoneInputAnyway: boolean = false;
  requireEmail: boolean = false;
  requirePhone: boolean = false;
  pageTitle: string = "Cart";
  submitDisabled: boolean = false;
  @ViewChild(CoReservationDetailsComponent) innerDetailsComponent: CoReservationDetailsComponent;
  @ViewChild('firstNameCardInput') firstNameCardInput: ElementRef;
  @ViewChild('lastNameCardInput') lastNameCardInput: ElementRef;
  @ViewChild('cardNumberInput') cardNumberInput: ElementRef;
  @ViewChild('expirationDateInput') expirationDateInput: ElementRef;
  @ViewChild('cvvInput') cvvInput: ElementRef;
  @ViewChild('contentContainer') contentContainerViewChild;

  constructor(public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController, private reserveProvider: ReserveProvider, private inAppBrowser: InAppBrowser, private platform: Platform, private events: Events, private modalCtrl: ModalController, private toast : ToastAlertsProvider, private timeout : TimeoutFunctionsProvider, private keyboard: Keyboard, private state: AppState, private sounds : SoundsProvider, private _clientDetailsProvider: ClientDetailsProvider) {
	this.events.subscribe('timeoutCalled', ()=> this.timeout.doLogoutFunctions(this));

    this.numberOfItems = this.navParams.data.currentCart.length;
    this.allItems = this.navParams.data.currentCart;
    this.barcode = this.navParams.data.barcode;
    this.currentItem = this.navParams.data.currentCart[0];
    this.clientKeyword = this.navParams.data.clientKeyword;
    this.previousPage = this.navParams.data.previousPage;
    this.viewingCart = this.navParams.data.viewingCart;
    this.isPopover = this.navParams.data.popover;
    this.mode = this.navParams.data.mode;
    this.viewType = this.navParams.data.viewType;
    this.clientRoomSettings = this.navParams.data.clientRoomSettings;
    this.isCostEnabled = this.navParams.data.isCostEnabled;
    this.clientName = this.navParams.data.clientName;
    this.detailsScreen = this.navParams.data.detailsScreen;
    this.libraryCardRequired = this.navParams.data.libraryCardRequired;
    this.tcOptional = this.navParams.data.tcOptional;
    this.hideNotes = this.navParams.data.hideNotes;
    this.sharedScreen = this.state.sharedScreen;
    this.blockSettings = this.navParams.data.blockSettings;
    this.termsOfServiceChecked = this.tcOptional;
    this.pinlessAuth = this.state.client.settings.client_pinless_auth || false;

    if (this.blockSettings){
      this.showEmailInputAnyway = this.blockSettings.showEmailInput || false;
      this.showPhoneInputAnyway = this.blockSettings.showPhoneInput || false;

      if (this.blockSettings.overrideSetRequireEmailTo !== null) this.clientRoomSettings.rooms_require_email = this.blockSettings.overrideSetRequireEmailTo;

      if (this.blockSettings.overrideSetRequirePhoneTo !== null) this.clientRoomSettings.rooms_require_phone = this.blockSettings.overrideSetRequirePhoneTo;
    }

    if (this.mode === 'single') this.clientRoomSettings.rooms_require_phone = false;
    // this.isCostEnabled = false;
    // console.log(this.blockSettings);
    if (this.numberOfItems === 1) {
      this.submitEnable = true;
    }
    this.emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    this.phoneRegex = new RegExp('^[^a-zA-Z]*$');
    this.cvvRegex = /^\d*$/;

    let lintWindow: any = window; //lint was breaking shit
    if(lintWindow.cordova && lintWindow.cordova.plugins && lintWindow.cordova.plugins.Keyboard) {
      lintWindow.cordova.plugins.Keyboard.disableScroll(false);
    }
    window.addEventListener('native.keyboardhide', this.scrollWindow);
  }

  scrollWindow() {
    window.scroll(0,window.scrollY);
  }

  ngOnDestroy() {
    let lintWindow: any = window; //lint was breaking shit
    if(lintWindow.cordova && lintWindow.cordova.plugins && lintWindow.cordova.plugins.Keyboard) {
      lintWindow.cordova.plugins.Keyboard.disableScroll(true);
    }
    window.removeEventListener('native.keyboardhide', this.scrollWindow);
  }

  ngAfterViewInit() {
    this.contentContainer = this.contentContainerViewChild.nativeElement.parentElement.parentElement;
    if (this.allItems.length > 0) {
      this.innerDetailsComponent.initializeDetails(this.currentItem.reserveStartTime, this.currentItem.reserveEndTime, this.currentItem, this.currentItemIndex, this.allItems[0].personalInfo);
    }
    this.totalCost();
    // console.log(this.clientRoomSettings);
    this.sounds.playSoundOnButtonClick();
  }

  hideModal(clearCart = false) {
    if(this.mode === "single") this.previousPage.emptyCart();
    this.viewCtrl.dismiss({ clearCart }).catch(err=>{});
  }

  nextItem() {
    this.validateFields(this.currentItem).then((res) => {
      if (res) {
        this.allRequiredFieldsFilled = false;

        if (this.currentItemIndex === this.allItems.length - 1) {
          return;
        }

        if (this.currentItemIndex < this.allItems.length - 1) {
          this.currentItemIndex++;
          this.previousEnable = true;
        }

        if (this.currentItemIndex === this.allItems.length - 1) {
          this.nextEnable = false;
          this.submitEnable = true;
        }

        let innerDetailsData = this.innerDetailsComponent.item.personalInfo;
        this.currentItem.personalInfo = innerDetailsData;

        this.currentItem = this.allItems[this.currentItemIndex];
        this.innerDetailsComponent.initializeDetails(this.currentItem.reserveStartTime, this.currentItem.reserveEndTime, this.currentItem, this.currentItemIndex, this.allItems[0].personalInfo);
        this.contentContainer.scroll(0, 0);
      }
    });
  }

  previousItem() {

    this.allRequiredFieldsFilled = false;

    if (this.currentItemIndex === 0) {
      return;
    }

    if (this.currentItemIndex > 0) {
      this.currentItemIndex--;
      this.nextEnable = true;
    }

    if (this.currentItemIndex === 0) {
      this.previousEnable = false;
    }

    let innerDetailsData = this.innerDetailsComponent.item.personalInfo;
    this.currentItem.personalInfo = innerDetailsData;

    this.currentItem = this.allItems[this.currentItemIndex];
    this.innerDetailsComponent.initializeDetails(this.currentItem.reserveStartTime, this.currentItem.reserveEndTime, this.currentItem, this.currentItemIndex, this.allItems[0].personalInfo);
    this.contentContainer.scroll(0, 0);
  }

  openCheckout() {
    if (this.checkoutScreen === true && this.submitEnable && this.termsOfServiceChecked) {
      let innerDetailsData = this.innerDetailsComponent.item.personalInfo;
      this.currentItem.personalInfo = innerDetailsData;
      this.validateFields(this.currentItem).then((res) => {
        if (res) {
          this.checkoutScreen = false;
          this.totalCost();

          this.contentContainer.scroll(0, 0);
        }
      })
    }
  }

  async validateFields(currentItem) {
    let output: any = [];
    this.validationObject.email = true;
    this.validationObject.phone = true;
    for (var key in currentItem.personalInfo) {
      if (currentItem.personalInfo[key] !== null) {
        switch (key) {
          case ('email'):
            if (!this.emailRegex.test(currentItem.personalInfo.email) && this.clientRoomSettings.rooms_require_email) {
              output.push('email');
            }
            break;
          case ('phone'):
            if (!this.phoneRegex.test(currentItem.personalInfo.phone) || currentItem.personalInfo.phone.length < 7 && this.clientRoomSettings.rooms_require_phone) {
              output.push('phone');
            }
            break;
        }
      }
    }
    output.forEach(input => {
      this.validationObject[input] = false;
    });
    this.innerDetailsComponent.formValidationFromCart(this.validationObject)
    return output.length <= 0;
  }

  closeCheckout() {
    this.contentContainer.scroll(0, 0);
    this.checkoutScreen = true;
  }

  totalCost() {
    this.finalCost = 0;


    this.allItems.forEach(element => {
      this.finalCost += element.totalPrice;
    });
    // this.finalCost = this.finalCost;
  }

  removeBooking(num) {
    this.allItems.splice(num, 1);
    // this.previousPage.removeBooking(num);
    this.events.publish('itemRemovedFromCart', this.allItems);
    this.numberOfItems = this.allItems.length;
    this.totalCost();
    this.currentItem = this.allItems[0];
    if (this.allItems.length > 0){
      if (this.numberOfItems === 1) {
        this.submitEnable = true;
      }
      this.innerDetailsComponent.initializeDetails(this.currentItem.reserveStartTime, this.currentItem.reserveEndTime, this.currentItem, this.currentItemIndex, this.currentItem.personalInfo);
    // this.needToUpdateCart = true;
    } else if (this.allItems.length <= 0) {
      this.hideModal();
    }
  }

  // updateCartSinceRemove() {
  //   this.hideModal();
  //   this.previousPage.goToCart('', false);
  // }

  async restructureReservation(reservation, payment?){
    let newObj:any = {}
    let customQuestionsArray = [];

    // for (let i = 0; i < reservation.personalInfo.customQuestions.length; i++){
    //   let obj = {name: reservation.room.customQuestions[i].field, value: reservation.personalInfo.customQuestions[i]};
    //   customQuestionsArray.push(obj);
    // }
    reservation.personalInfo.customQuestions.forEach((question, i) => {
      let obj = {name: reservation.room.customQuestions[i].name, value: question? question.toString() : ''};
      customQuestionsArray.push(obj);
    });
    newObj.roomID = reservation.room.id;
    newObj.cartId = reservation.cartId;
    newObj.includeNotification = true;

    newObj.contact = {
      firstName: reservation.personalInfo.firstName,
      lastName: reservation.personalInfo.lastName,
      title: (reservation.personalInfo.bookingTitle) ? reservation.personalInfo.bookingTitle: '',
      email: (reservation.personalInfo.email) ? reservation.personalInfo.email: '',
      phone: (reservation.personalInfo.phone) ? reservation.personalInfo.phone: '',
      displayName: (reservation.personalInfo.displayName) ? reservation.personalInfo.displayName: '',
      groupName: (reservation.personalInfo.groupName) ? reservation.personalInfo.groupName: '',
      attendees: (reservation.personalInfo.attendees) ? +reservation.personalInfo.attendees: 0,
      notes: (reservation.personalInfo.note) ? reservation.personalInfo.note: '',
      customQuestions: customQuestionsArray
    }

    if(false == this.state.omitCardFromReserveBooking)  {
      newObj.contact.card =  (reservation.personalInfo.libraryCard) ? reservation.personalInfo.libraryCard: '';
    }

    if (reservation.chosenLayout){
      newObj.layoutID = (reservation.chosenLayout.id) ? reservation.chosenLayout.id: 0;
    } else {
      newObj.layoutID = 0;
    }
    if (payment) {
      newObj.card = {
        number: this.cardNumberInput.nativeElement.value,
        firstName: this.firstNameCardInput.nativeElement.value,
        lastName: this.lastNameCardInput.nativeElement.value,
        expirationDate: this.expirationDateInput.nativeElement.value,
        cvv: this.cvvInput.nativeElement.value
      }
    }


    newObj.bookingEndTime = reservation.reserveEndTime;
    newObj.bookingStartTime = reservation.reserveStartTime;

    const userClasses = await this._clientDetailsProvider.userClasses();
    const userClass = userClasses.find(c => c.id === reservation.personalInfo.userClassId);

    newObj.classID = reservation.personalInfo.userClassId;
    newObj.classType = userClass ? Math.min(1, userClass.type) : 1;

    return newObj;
  }

  async submitReservation() {
    this.submitDisabled = true;
    let onScreenTime = 30000;
    if (!this.isCostEnabled || this.paymentType === 'offline' || this.finalCost === 0) {
      let outputArray = [];
      for(let reservation of this.allItems) {
        await this.restructureReservation(reservation).then(res=> outputArray.push(res));
      }

      if (this.state.demo && this.state.client.id !== 232){ // WE WANT REAL BOOKINGS ON CUYAHOGA DEMO CLIENT
        this.submitDisabled = false;
        if (outputArray.length > 1) {
          this.toast.showAlert('', "Thank you, your reservations have been booked!", "success", 5000);
          this.hideModal();
        } else {
          this.toast.showAlert('', "Thank you, your reservation has been booked!", "success", 5000);
          this.hideModal();
        }
        this.previousPage.emptyCart();
        this.previousPage.setCurrentDate();
        if (this.detailsScreen) {
          this.previousPage.viewCtrl.dismiss().catch(err=>{});
        }
        return;
      }
      // console.log('submitting real reservation');
      this.reserveProvider.createReservation(outputArray, this.state.productType).then((res) => {
        this.submitDisabled = false;
        if (res.success === res.total) {
          if (res.total > 1) {
            this.toast.showAlert('', `Thank you, your reservations have been booked!<br/>${(res.bookingResponses[0].data.remotelock_has_code ? 'The room lock codes for each of your bookings have been emailed to you.' : '')}`, "success", onScreenTime);
            this.hideModal(true);
          } else {
            this.toast.showAlert('', `Thank you, your reservation has been booked!<br/>${(res.bookingResponses[0].data.remotelock_has_code ? 'Your room lock code is ' + res.bookingResponses[0].data.remotelock_lock_code : '')}`, "success", onScreenTime);
            this.hideModal(true);
          }
          this.previousPage.emptyCart();
          this.previousPage.setCurrentDate();
          if (this.detailsScreen) {
            this.previousPage.viewCtrl.dismiss().catch(err=>{});
          }
        } else {
          res.bookingResponses.forEach(booking => {
            if (booking.ok) {
              this.previousPage.removeBooking(-1, booking.cartId);
            }
          });

          this.previousPage.resetCartIds();

          if (res.total > 1) {
            this.toast.showAlert('', "Sorry, there was an error booking your rooms. Bookings that were successful will be removed from your cart.", "warning", onScreenTime);
          } else {
            let message = res.bookingResponses[0].message;
            switch(message) {
              case "userClass.furthestBookingDays.exceeded":
                message = "This booking is too far in the future.";
                break;
              case "userClass.nearestBookingDays.exceeded":
                message = "This booking is too close to the current date.";
                break;
            }
            this.toast.showAlert('', `Sorry, there was an error booking your room.<br/>${message}`, 'warning', onScreenTime);
          }
        }
      }).catch( () => this.submitDisabled = false );
    } else if (this.paymentType === 'card') {
      let outputArray = [];

      await this.getCreditInput().then(res => {
        if (res) {
          this.allItems.forEach(reservation => {
            this.restructureReservation(reservation, true).then(res=> outputArray.push(res));
          });

          this.reserveProvider.createReservation(outputArray[0], this.state.productType).then((res) => {
            this.submitDisabled = false;
            if (res.success === res.total) {
              this.hideModal(true);
              if (res.total > 1) {
                this.toast.showAlert('', "Thank you, your reservations have been booked!", "success", onScreenTime);
              } else {
                this.toast.showAlert('', "Thank you, your reservation has been booked!", "success", onScreenTime);
              }
              this.previousPage.emptyCart();
              this.previousPage.setCurrentDate();
              if (this.detailsScreen) {
                this.previousPage.viewCtrl.dismiss().catch(err=>{});
              }
            } else {
              res.bookingResponses.forEach(booking => {
                if (booking.ok) {
                  this.previousPage.removeBooking(-1, booking.cartId);
                }
              });

              if (res.total > 1) {
                this.toast.showAlert('', "Sorry, there was an error booking your rooms. Bookings that were successful will be removed from your cart.", "warning", onScreenTime);
              } else {
                this.toast.showAlert('', "Sorry, there was an error booking your room.", 'warning', onScreenTime);
              }
            }
          }).catch( () => this.submitDisabled = false );
        } else {
          this.submitDisabled = false;
          this.emptyInputFieldStatus = true;
          // console.log('weeeee', !this.isCostEnabled, this.paymentType === 'offline', !this.emptyInputFieldStatus);
        }
      }).catch( () => this.submitDisabled = false );
    }
  }

  goToBookingDetails() {
    if (this.isPopover) {
      this.viewCtrl.dismiss().catch(err=>{});
      this.previousPage.goToCart('', true);
    } else {
      this.pageTitle = "Checkout";
      this.viewingCart = true;
      this.contentContainer.scroll(0, 0);
      // this.innerDetailsComponent.initializeDetails(this.currentItem.reserveStartTime, this.currentItem.reserveEndTime, this.currentItem);
    }
  }

  async getCreditInput() {
    this.cardNumberInput.nativeElement.value ? this.cardInfoObject.cardNum = this.cardNumberInput.nativeElement.value : this.cardInfoObject.cardNum = null;

    this.cvvInput.nativeElement.value ? this.cardInfoObject.cvvNum = this.cvvInput.nativeElement.value : this.cardInfoObject.cvvNum = null;

    this.expirationDateInput.nativeElement.value ? this.cardInfoObject.expDate = this.expirationDateInput.nativeElement.value : this.cardInfoObject.expDate = null;

    this.firstNameCardInput.nativeElement.value ? this.cardInfoObject.firstName = this.firstNameCardInput.nativeElement.value : this.cardInfoObject.firstName = null;

    this.lastNameCardInput.nativeElement.value ? this.cardInfoObject.lastName = this.lastNameCardInput.nativeElement.value : this.cardInfoObject.lastName = null;
    this.cardInfoIsEntered = { cardNum: true, cvvNum: true, expDate: true, firstName: true, lastName: true };

    let empty = [];
    for (var key in this.cardInfoObject) {
      if (this.cardInfoObject[key] === null) {
        empty.push(key);
      }
    }
    empty.forEach(input => {
      this.cardInfoIsEntered[input] = false;
    });

    if (empty.length <= 0) {
      return this.validateCreditInfo();
    } else {
      return false
    }
  }

  validateCreditInfo() {
    let output = []
    for (var key in this.cardInfoObject) {
      switch (key) {
        case ('cvvNum'):
          if (this.cardInfoObject.cvvNum.length < 3 || this.cardInfoObject.cvvNum.length > 4) {
            output.push(key);
            break;
          }
      }
    }

    output.forEach(input => {
      this.cardInfoIsEntered[input] = false;
    })

    return output.length <= 0
  }

  checkRequiredFields(item) {
    let allFieldsFilled: boolean = true;
    let personalInfo: any = {};
    if (item.personalInfo) personalInfo = item.personalInfo;
    if (this.libraryCardRequired) {
      if (!personalInfo.libraryCard && (!personalInfo.pin || this.pinlessAuth)) {
        this.allRequiredFieldsFilled = false;
        return;
      }

      if (!item.detailsRetrieved) {
        this.allRequiredFieldsFilled = false;
        return;
      }
    }

    if (!personalInfo.firstName) {
      this.allRequiredFieldsFilled = false;
      return;
    }
    if (!personalInfo.lastName) {
      this.allRequiredFieldsFilled = false;
      return;
    }
    if (!personalInfo.email && !this.blockSettings.settings?.['hideEmailInput'] && (this.clientRoomSettings.rooms_require_email || this.blockSettings.requireEmail)) {
      this.allRequiredFieldsFilled = false;
      return;
    }

    if (!personalInfo.phone && !this.blockSettings.settings?.['hidePhoneInput'] && (this.clientRoomSettings.rooms_require_phone || this.blockSettings.requirePhone)) {
      this.allRequiredFieldsFilled = false;
      return;
    }
    if (!personalInfo.bookingTitle && !(this.blockSettings && this.blockSettings.hideBookingTitle)) {
      this.allRequiredFieldsFilled = false;
      return;
    }
    if (this.mode === "multi" && !personalInfo.groupName) {
      this.allRequiredFieldsFilled = false;
      return;
    }
    if (this.mode === "multi" || this.state.showAttendees) {
      if(!this.state.staff && !personalInfo.attendees) { // patrons cannot have 0 attendees
        this.allRequiredFieldsFilled = false;
        return;
      } else if(personalInfo.attendees === undefined) { // staff can have 0 attendees but the field is required
        this.allRequiredFieldsFilled = false;
        return;
      }
    }
    if (item.room.customQuestions){
    item.room.customQuestions.forEach((question, i) => {
      if (question.required) {
          if (personalInfo.customQuestions[i] === null) {
            allFieldsFilled = false;
          }
        }
        // if (personalInfo.customQuestions[i] === null) {
        //   console.log(i, question);
        //   allFieldsFilled = false;
        // }
      });
    }
    this.allRequiredFieldsFilled = allFieldsFilled;
  }

  openTCLink() {
    if (!this.currentItem.room.tcLink) {
      return;
    }

    if (this.state.roomBooker || this.platform.is('core')) {
      let modal = this.modalCtrl.create(CoTcModalPage, { url: this.currentItem.room.tcLink })
      modal.present();
    } else {
      this.inAppBrowser.create(this.currentItem.room.tcLink, '_system');
    }
  }

  checkTermsOfService() {
    this.termsOfServiceChecked = !this.termsOfServiceChecked;
  }
}



// WEBPACK FOOTER //
// ./src/pages/co-cart/co-cart.ts